<ng-template [ngIf]="winningCoupons.length && showTopWinnings">
  <p-accordion>
    <p-accordionTab [(selected)]="!collapsed" header="{{ 'RACES.TOP_WINNINGS' | translate }}">
      <div class="tabbassiCard card winning-card">
        <div class="card-body p-0">
          <table class="table tdBottomBorder mb-0 border-inherit">
            <tbody>
              <tr *ngFor="let coupon of winningCoupons | slice:0:3; let i = index">
                <a class="c-p" (click)="raceDetail(coupon)">
                  <td class="w-3">
                    <img src="../../../../assets/media/wining/{{i+1}}.webp" alt="{{i}} Cup" />
                  </td>
                  <td>
                    {{coupon?.user?.username}}
                  </td>
                  <td class="text-right">
                    {{coupon?.betslip?.winnings| number: "1.2-2" }} {{authService.currentCurrency$ | async | uppercase}}
                  </td>
                </a>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
  <div class="space-10"></div>
</ng-template>